module.exports = __webpack_public_path__ + "img/SignificantGaps.81fdb1fd.jpg";